module.exports = __webpack_public_path__ + "img/Paso 3.95d3df27.png";